export const indicateWheatType = (sort: string, type: string ) => {
    if (sort === 'мягкая краснозерная' && type === 'яровая') return 1;
    if (sort === 'твердая' && type === 'яровая') return 2;
    if (sort === 'мягкая белозерная' && type === 'яровая') return 3;
    if (sort === 'мягкая краснозерная' && type === 'озимая') return 4;
    if (sort === 'мягкая белозерная' && type === 'озимая') return 5;
    if (sort === 'твердая' && type === 'озимая') return 6;
}

export const spreadWheatType = (type: number) => {
    if (type === 1) return { sort: 'мягкая краснозерная', type: 'яровая' }
    if (type === 2) return { sort: 'твердая', type: 'яровая' }
    if (type === 3) return { sort: 'мягкая белозерная', type: 'яровая' }
    if (type === 4) return { sort: 'мягкая краснозерная', type: 'озимая' }
    if (type === 5) return { sort: 'мягкая белозерная', type: 'озимая' }
    if (type === 6) return { sort: 'твердая', type: 'озимая' }
}

export const multiWheatType = (sort: string[], type: string[]) => {
    const res = [];
    if (sort.includes('мягкая краснозерная') && type.includes('яровая')) res.push(1);
    if (sort.includes('твердая') && type.includes('яровая')) res.push(2);
    if (sort.includes('мягкая белозерная') && type.includes('яровая')) res.push(3);
    if (sort.includes('мягкая краснозерная') && type.includes('озимая')) res.push(4);
    if (sort.includes('мягкая белозерная') && type.includes('озимая')) res.push(5);
    if (sort.includes('твердая') && type.includes('озимая')) res.push(6);
    return res;
}